import { Button, Group, Select, Tooltip } from '@mantine/core'
import { IconEyeOff } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { trpc } from '../queryClient.ts'
import { useErrorNotifier } from '../tools/errors.tsx'


interface FilterProps {
  showHidden: boolean
  onToggleShowHidden(): void
  onLocationSelect(location?: string): void
}

export function Filters({ showHidden, onToggleShowHidden, onLocationSelect }: FilterProps) {
  const { data: cinemas, isLoading, error } = useQuery(trpc.cinema.all.queryOptions())
  useErrorNotifier('Error fetching cinemas', error)

  const locations = useMemo(() => {
    return Array.from(new Set<string>(cinemas?.map(cinema => cinema.location)))
  }, [cinemas])

  return (
    <Group>
      {onToggleShowHidden && (
        <Tooltip label={showHidden ? 'Hide hidden movies' : 'Show hidden movies'} openDelay={500}>
          <Button variant="subtle" c={showHidden ? 'white' : 'dark.2'} onClick={onToggleShowHidden}>
            <IconEyeOff/>
          </Button>
        </Tooltip>
      )}
      {onLocationSelect && (
        <Select
          visibleFrom="xs"
          disabled={!locations.length || isLoading || !!error}
          placeholder="Filter by location"
          data={locations}
          onChange={value => onLocationSelect(value || undefined)}
          clearable
        />
      )}
    </Group>
  )
}
